<template>
  <div :id="qrcodeId" ref="qrcode" class="qrcode">二维码图片</div>
</template>

<script>
import { mapState } from "vuex";
import QRCode from "qrcodejs2";
export default {
  name: "qrcode",
  props: {
    link: {
      type: String,
      default: ""
    },
    codeW: {
      type: [String, Number],
      default: 110
    }
  },
  data() {
    return {
      qrcode: null
    };
  },
  watch: {
    link: {
      handler(val) {
        setTimeout(() => {
          this.qrcodeScan(val);
        }, 200);
      },
      immediate: true
    }
  },
  computed: {
    ...mapState("companyInfo", {
      company: state => {
        return state.company;
      }
    }),

    qrcodeId() {
      return "qrcode" + Math.round(Math.random() * 1000);
    }
  },
  methods: {
    //生成二维码
    qrcodeScan(text) {
      const w = Number(this.codeW);
      this.$refs.qrcode.innerHTML = "";
      this.qrcode = new QRCode(this.qrcodeId, {
        width: w, // 设置宽度，单位像素
        height: w, // 设置高度，单位像素
        text, // 设置二维码内容或跳转地址
        colorDark: "#000000",
        colorLight: "#FFFFFF"
      });
      if (this.company.emblem) {
        // 添加二维码中间的图片
        let logo = new Image();
        logo.setAttribute("crossOrigin", "Anonymous");
        const imageUrl = this.company.emblem + "&time=" + new Date().getTime();
        logo.src = imageUrl;
        logo.onload = () => {
          let qrImg = this.qrcode._el.getElementsByTagName("img")[0];
          let canvas = this.qrcode._el.getElementsByTagName("canvas")[0];
          this.qrcode._el.title = text;
          canvas.style.display = "inline-block";
          let ctx = canvas.getContext("2d");
          // 设置logo的大小为二维码图片缩小的4倍，第二与第三参数代表logo在二维码的位置
          ctx.drawImage(logo, (w - w / 4) / 2, (w - w / 4) / 2, w / 4, w / 4);
          qrImg.src = canvas.toDataURL();
          qrImg.style.display = "none";
        };
      }
    }
  }
};
</script>

<style lang="less" scoped>
.qrcode {
  padding: 10px;
  box-shadow: 0 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  display: flex;
  background-color: #fff;
  justify-content: center;
  align-items: center;
}
</style>
